<!--Login Page Starts-->
<div class="l-form">
  <div class="shape1"></div>
  <div class="shape2"></div>
  <div class="shape3"></div>
  <div class="shape4"></div>

  
<section id="login" >
  <div class="row auth-height full-height-vh m-0">
    <div class="col-12 d-flex align-items-center justify-content-center flex-column">
      <div class="card overflow-hidden">
        <div class="card-header">
          <p>بطاقة تهنئة</p> 
        </div>
        <div class="card-content">
          <div class="card-body auth-img">
            <div class="row row-card-login ">
              <div class="col-lg-8 col-12 px-4 py-3 card-col-6 ">
                  <div class="col-12" style="border: 1px dashed green; margin-bottom: 20px;">
                    <img class="image-canvas" width="250px" height="250px" src="{{img_path}}">
                  </div>
                  <div class="form-group">
                    <label class="mb-2">ادخل اسم الطالب / الطالبة</label>
                    <input #name dir="rtl" type="text" class="form-control">
                  </div>
                  <div class="form-group">
                    <button class="btn btn-grad" (click)="Print(name.value)">طباعة</button>
                  </div>
              </div>
              <div class="col-lg-4  auth-img-bg  text-center">
                <div class="d-flex justify-content-center">
                <img src="../../../../assets/img/nbulogo-01.png" alt="" class="img-fluid" width="300" height="75">
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</div>

<div class="popup-left " [class.active]="openPopup">
  <div class="overlay-div"></div>
  <div class="modal-header p-0 align-items-center">
   
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      
      <span aria-hidden="true">&times;</span>
      
    </button>
    <button class="btn btn-grad mt-1 mb-1" (click)="downloadImage()"><i class="ft-download"></i></button>
  </div>
  <div class="modal-body card ">
    <canvas height="900" width="650" #canvas></canvas>
   
  </div>
 
</div>

